import { useContext, useEffect, useState } from "react";
import ContextFlujos from "../Context/ContextFlujos";
import styles from "../Pagos/MetodosPago/ModalPaypal.module.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import {
  DatosTarjetaEntrada,
  DatosTransaccionEntrada,
  builtDatosTarjetaEntrada,
  builtDatosTransaccionEntrada,
  builtOrquestarProcesoPago_Entrada,
  OrquestarProcesoPago_Parametros,
  OrquestarProcesoPago_Respuesta,
  builtEBMHeaderRequest,
} from "../Commons/Services/GwOrquestarProcesoPagoPMPEBFPaypal";
import { ConsultaWS } from "../Commons/ServiciosBase";
import Loading from "../General/Loading";
import { useNavigate } from "react-router-dom";
import { ConsultarBines_Respuesta } from "../Commons/Services/GwConsultarBinesEBS";
import {
  GenerarIdentificadorUnicoDePago_Entrada,
  GenerarIdentificadorUnicoDePago_Parametros,
  GenerarIdentificadorUnicoDePago_Respuesta,
  builtInputVarGenerarIdentificadorUnicoDePagoInput,
} from "../Commons/Services/GwGenerarIdentificadorUnicoDePagoEBS";
import { v4 as uuidv4 } from "uuid";

const PagoExitosoPaypal = () => {
  const { skyPlus, setSkyPlus, setSkyCelular, pais, setPais, paypalContext, setDTHSkyPlus } =
    useContext(ContextFlujos) as any;

  const navigate = useNavigate();

  const [loading, isLoading] = useState(false);
  const [exito, setExito] = useState(false);
  const [uuidValue, setUuidValue] = useState(0);
  const { REACT_APP_URL_PAYPAL } = process.env;

  const orquestaPago = async () => {
    const jsonPaypal = sessionStorage.getItem("paypal");

    if (jsonPaypal !== null) {
      let obj = JSON.parse(jsonPaypal!);
      isLoading(true);

      //const uuid = uuidv4.toString();

      let rowId = doValidareLoginUser();

      const ar = obj.codigoSky?.split("_");
      const idTransaccion = ar![2];

      // const parametroItem= builtParametroItem("","");
      // const seguridadItem = builtSeguridadItem("SOAPUI", "soadevadm", "S04D3v2022#");
      // const parametroList = builtParametroList([parametroItem]);
      // const seguridadList = builtSeguridadList([seguridadItem]);
      const eBMHeaderRequest = builtEBMHeaderRequest(
        "OrquestarProcesoPago",
        "Web"
      );
      const datosTarjetaEntrada: DatosTarjetaEntrada = builtDatosTarjetaEntrada(
        "",
        "",
        "",
        "",
        "",
        ""
      );
      const datosTransaccionEntrada: DatosTransaccionEntrada =
        builtDatosTransaccionEntrada(
          "AplicarPago",
          idTransaccion,
          sessionStorage.getItem("cuenta")!,
          rowId,
          horaFormateada(),
          fechaFormateada(),
          "1",
          obj.monto,
          obj.monto,
          "1",
          "Mexico",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Web",
          "MXP",
          "",
          "",
          "",
          "Pago con PayPal",
          obj.merchantId,
          obj.codigoSky,
          "false",
          obj.token,
          "",
          `${sessionStorage.getItem("idSesion")}`,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "TRUE",
          "VENTA_DIRECTA"
        );

      const orquestarProcesoPagoEntrada = builtOrquestarProcesoPago_Entrada(
        eBMHeaderRequest,
        datosTarjetaEntrada,
        datosTransaccionEntrada
      );
      const parametros = OrquestarProcesoPago_Parametros(
        orquestarProcesoPagoEntrada
      );
      const respuesta: OrquestarProcesoPago_Respuesta = await ConsultaWS(
        parametros
      );

      if (
        respuesta.EBMHeaderResponse.ErrorNegocio.Estado === "ok" &&
        respuesta.EBMHeaderResponse.ErrorNegocio.CodigoError === "0"
      ) {
        const urlExitosa = jsonPaypal;
        sessionStorage.removeItem("paypal");
        isLoading(false);
        setExito(true);
      } else {
        sessionStorage.removeItem("paypal");
        isLoading(false);
        setExito(false);
      }
    }
  };

  const doValidareLoginUser = () => {
    if (sessionStorage.getItem("flujos") !== "Sky+") {
      return sessionStorage.getItem("rowId")!;
    } else {
      return uuidv4();
    }
  };

  function horaFormateada() {
    var momentoActual = new Date();
    var hora = momentoActual.getHours();
    var minuto = momentoActual.getMinutes();
    var segundo = momentoActual.getSeconds();

    let horaImprimible = hora + "" + minuto + "" + segundo;
    return horaImprimible;
  }

  function fechaFormateada() {
    var today = new Date();
    var day = today.getDate();
    var month = today.getMonth() + 1;
    var year = today.getFullYear();
    let fechaImprimible =
      formatDAYMONTHYEAR("anho", year.toString()) +
      "" +
      formatDAYMONTHYEAR("mes", month.toString()) +
      "" +
      formatDAYMONTHYEAR("dia", day.toString());
    return fechaImprimible;
  }

  const formatDAYMONTHYEAR = (nombre: string, valor: string) => {
    if (nombre === "dia" || nombre === "mes") {
      if (valor.length == 1) {
        return "0" + valor;
      } else {
        return valor;
      }
    } else if (nombre === "anho") {
      return valor.substring(2, 4);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("flujos") === "Sky+") {
      setSkyPlus({ estado: false });
      setPais("MEX");
      setDTHSkyPlus({ estado: false });

    } else {
      setPais(sessionStorage.getItem("pais"));
    }

    if (
      sessionStorage.getItem("flujos") === "DTH/SkyCelular" ||
      sessionStorage.getItem("flujos") === "DTH/DTH/SkyCelular/Sky+"
    ) {
      setSkyCelular({ estado: true });
    }

    if (sessionStorage.getItem("flujos") ===  "DTH/Sky+" || sessionStorage.getItem("flujos") ===  "DTH/SkyCelular/Sky+") {
      setDTHSkyPlus({estado:false});
    }

    if (sessionStorage.getItem("flujos") ===  "DTH" || sessionStorage.getItem("flujos") ===  "DTH/SkyCelular") {
      setDTHSkyPlus({estado:true});
    }

    orquestaPago();
  }, []);

  return (
    <>
      <Loading isLoading={loading} />
      <Container className={styles.containerPagina}>
        <Row>
          <Col>
            {loading === true ? (
              <h2 className={styles.titulo}>Procesando pago...</h2>
            ) : (
              <></>
            )}
            {exito === true ? (
              <>
                <h2 className={styles.titulo}>
                  <span className="textoSpectrum">
                    Su pago ha sido exitoso.
                  </span>
                </h2>
              </>
            ) : loading === false ? (
              <>
                <h2 className={styles.titulo}>
                  Hubo un error en la transacción.
                </h2>
              </>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PagoExitosoPaypal;
